var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-546.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(301.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1DB4CF",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.515625,13.3455479 C10.2226562,13.3923839 10,13.6385167 10,13.9314854 L10,19.7908604 L18.2421875,19.7908604 L18.2421875,12.3846104 L10.515625,13.3455479 Z M29.8008203,11.1423839 C29.671875,11.0368761 29.5078516,10.9900401 29.3437891,11.0017589 L19.4140625,12.2439464 L19.4140625,19.7908214 L30,19.7908214 L30,11.5876964 C30,11.4236339 29.9296875,11.2595714 29.8008203,11.1423839 Z M19.4140625,20.9627354 L19.4140625,28.5213292 L29.34375,29.7517979 L29.4140625,29.7517979 C29.5546875,29.7517979 29.6953125,29.7048839 29.8008203,29.6111729 C29.9297266,29.4939464 30,29.3299229 30,29.1658604 L30,20.9627354 L19.4140625,20.9627354 Z M10,20.9627354 L10,26.8221104 C10,27.1150792 10.2226562,27.3611339 10.515625,27.4080479 L18.2421875,28.3689854 L18.2421875,20.9627354 L10,20.9627354 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWindows);
export default __webpack_public_path__ + "static/media/icWindows.201c98b03bbfa560c200a233d29fa216.svg";
export { ForwardRef as ReactComponent };